const featuresData = [
  { id: 1, icon: "fas fa-certificate", title: "Certified Technicians", desc: "Expert team" },
  { id: 2, icon: "fas fa-shield-alt", title: "Genuine Parts", desc: "Original parts" },
  { id: 3, icon: "fas fa-rupee-sign", title: "Transparent Pricing", desc: "No hidden charges" },
  { id: 4, icon: "fas fa-clock", title: "Quick Response", desc: "Fast service" },
  { id: 5, icon: "fas fa-map-marker-alt", title: "PAN India", desc: "100+ cities" },
  { id: 6, icon: "fas fa-headset", title: "24/7 Support", desc: "Always available" }
];
export default featuresData;